(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("bluebird"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "bluebird"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("bluebird")) : factory(root["underscore"], root["bluebird"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__38__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 62);
/******/ })
/************************************************************************/
/******/ ({

/***/ 38:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__38__;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(64);

Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index[key];
    }
  });
});

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(65);

Object.keys(_lodash).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lodash[key];
    }
  });
});

var _string = __webpack_require__(66);

Object.keys(_string).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _string[key];
    }
  });
});

var _guid = __webpack_require__(67);

Object.keys(_guid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _guid[key];
    }
  });
});

var _date = __webpack_require__(68);

Object.keys(_date).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _date[key];
    }
  });
});

var _file = __webpack_require__(69);

Object.keys(_file).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _file[key];
    }
  });
});

var _promise = __webpack_require__(70);

Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _promise[key];
    }
  });
});

var _color = __webpack_require__(71);

Object.keys(_color).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _color[key];
    }
  });
});

var _number = __webpack_require__(72);

Object.keys(_number).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _number[key];
    }
  });
});

var _memoize = __webpack_require__(73);

Object.keys(_memoize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _memoize[key];
    }
  });
});

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sumBy = sumBy;
exports.merge = merge;
exports.get = get;
exports.set = set;
exports.flow = flow;
exports.isNil = isNil;
exports.cloneDeep = cloneDeep;
exports.uniqWith = uniqWith;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Task 904718: refactor to use explicit dependency for es6 syntax rather than global variable

/* global Map */
function castPath(value, object) {
  if (_underscore.default.isArray(value)) {
    return value;
  }

  if (_underscore.default.has(object, value)) {
    return [value];
  }

  return _underscore.default.compact(value.split(/[[\].]/));
}

function clone(item, sourceCopyMap) {
  if (!_underscore.default.isObject(item) || _underscore.default.isDate(item)) {
    return item;
  }

  if (!sourceCopyMap.get(item)) {
    var result_1 = _underscore.default.isArray(item) ? [] : {};
    sourceCopyMap.set(item, result_1);

    _underscore.default.each(item, function (value, key) {
      result_1[key] = clone(value, sourceCopyMap);
    });
  }

  return sourceCopyMap.get(item);
}
/**
 * defined in lodash 4.5.1
 * sum list with iteratee
 * @param {Object[]} list - array to be summed
 * @param {Function} invoke - function invoked per element
 * @returns {number} - sum value of list
 */


function sumBy(list, invoke) {
  var iteratee = undefined; // make separate calls to satisfy @types/underscore for iteratee

  if (invoke instanceof String) {
    iteratee = _underscore.default.iteratee(invoke);
  } else if (invoke instanceof Object) {
    iteratee = _underscore.default.iteratee(invoke);
  } else {
    iteratee = _underscore.default.iteratee(invoke);
  }

  return _underscore.default.reduce(list, function (currentSum, item, index, arr) {
    return currentSum + iteratee(item, index, arr);
  }, 0);
}
/**
 * defined in lodash 0.5.0
 * merge two object from src to dest
 * @param {Object} dest - dest object
 * @param {Object} src - src object
 * @returns {Object} - merged object
 */


function merge() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return _underscore.default.reduce(_underscore.default.rest(args), function (dest, src) {
    _underscore.default.each(src, function (value, key) {
      var destKey = dest[key];

      if (_underscore.default.isObject(destKey) && _underscore.default.isObject(value) && !_underscore.default.isFunction(value)) {
        merge(destKey, value);
      } else {
        _underscore.default.extend(dest, _underscore.default.object([key], [value]));
      }
    });

    return dest;
  }, _underscore.default.first(args) || {});
}
/**
 * defined in lodash 4.6.1
 * Gets the value at path of object. If the resolved value is undefined,
 * the defaultValue is returned in its place.
 * @param {Object} object - The object to query.
 * @param {array|string} path - The path of the property to get.
 * @param {*} defaultValue - Optional, The value returned for undefined resolved values.
 * @returns {any} - return the value in object by path, if not exist, return default value
 */


function get(object, path, defaultValue) {
  var sub;
  var i;
  var keyPath = castPath(path, object);

  for (i = 0, sub = object; i < keyPath.length; i += 1) {
    if (!_underscore.default.isObject(sub)) {
      return defaultValue;
    }

    sub = sub[keyPath[i]];

    if (_underscore.default.isUndefined(sub)) {
      return defaultValue;
    }
  }

  return sub;
}
/**
 * lodash set, path don't support index
 * Sets the value at path of object. If a portion of path doesn't exist, it's created.
 * Arrays are created for missing index properties while
 * objects are created for all other missing properties.
 * @param {Object} object - The object to modify.
 * @param {string} path - The path of the property to set.
 * @param {*} value - The value to set.
 * @returns {Object} - Returns object.
 */


function set(object, path, value) {
  if (!_underscore.default.isObject(object)) {
    return object;
  }

  var keyPath = castPath(path, object);
  var index = 0;
  var length = keyPath.length;
  var lastIndex = length - 1;
  var nested = object;

  while (nested != null && index < length) {
    var key = keyPath[index];

    if (index !== lastIndex) {
      nested[key] = nested[key] || {};
      nested = nested[key];
    } else {
      nested[key] = value;
    }

    index += 1;
  }

  return object;
}
/**
 * Creates a function that returns the result of invoking the given
 * functions with the this binding of the created function,
 * where each successive invocation is supplied the return value of the previous.
 * lodash flow https://lodash.com/docs#flow
 * @param {function[]} funcs - The functions to invoke.
 * @returns {Function} - Returns the new composite function.
 */


function flow() {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  return _underscore.default.compose.apply(null, funcs.reverse());
}
/**
 * defined in lodash 4.0.0
 * Check whether value is undefined or null
 * @param {*} value - value to Check
 * @returns {boolean} - return true if value is undefined or null, otherwise, return false
 */


function isNil(value) {
  return _underscore.default.isUndefined(value) || _underscore.default.isNull(value);
}
/**
 * deep clone object
 * @param {array|Object} item - source item to be copied
 * @return {array|Object} - copied from item
*/


function cloneDeep(item) {
  return clone(item, new Map());
}

function objIsArray(obj) {
  return _underscore.default.isArray(obj) && Boolean(obj.length);
}
/**
 * array dedup function
 * @param {any[]} array - the array to inspect
 * @param {function} comparator - comparator function to determine whether 2 elements are the same
 * @returns {any[]} - new duplicate free array
 */


function uniqWith(array, comparator) {
  if (!objIsArray(array)) {
    return [];
  }

  if (!_underscore.default.isFunction(comparator)) {
    return _underscore.default.uniq(array);
  }

  var result = [];

  _underscore.default.each(array, function (obj) {
    if (_underscore.default.every(result, function (res) {
      return !comparator(obj, res);
    })) {
      result.push(obj);
    }
  });

  return result;
}

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.curlyTemplate = curlyTemplate;
exports.hasCJK = hasCJK;
exports.displayLength = displayLength;
exports.getLength = getLength;
exports.isControl = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noMatch = /(.)^/;
var settings = {
  escape: noMatch,
  evaluate: noMatch,
  interpolate: /\{\{(.+?)\}\}/g
};
/**
 * Passes constant double curly brace settings to the underscore template function.
 * E.g. to support templates of the format: 'The bid is {{bidAmount}}'
 *
 * @see {@link http://underscorejs.org/#template}
 *
 * @param {String} templateString - The template markup that contains double curly bracket notation.
 * @return {Function} The template function, which can be passed an Object model with fields that
 *    correspond to the names marked up by the curly braces.
 */

function curlyTemplate(templateString) {
  return _underscore.default.template(templateString, settings);
}
/**
 * check whether this string include CJK charact
 * @param {string} str - string to check
 * @returns {boolean} - return true if str contains CJK, otherwise, return false
 */


function hasCJK(str) {
  return !!(_underscore.default.isString(str) && str.match(/[\u4E00-\u9FCC]/));
}
/**
 * Regex Pattern for wide characters
 */


var wideCharPattern = new RegExp('[\\u1100-\\u11FF]' + // IsHangulJamo
'|[\\u2E80-\\u2EFF]' + // IsCJKRadicalsSupplement
'|[\\u3000-\\u303F]' + // IsCJKSymbolsandPunctuation
'|[\\u3040-\\u309F]' + // IsHiragana
'|[\\u30A0-\\u30FF]' + // IsKatakana
'|[\\u3130-\\u318F]' + // IsHangulCompatibilityJamo
'|[\\u3200-\\u32FF]' + // IsEnclosedCJKLettersandMonths
'|[\\u3300-\\u33FF]' + // IsCJKCompatibility
'|[\\u3400-\\u4DBF]' + // IsCJKUnifiedIdeographsExtensionA
'|[\\u4E00-\\u9FFF]' + // IsCJKUnifiedIdeographs
'|[\\uAC00-\\uD7AF]' + // IsHangulSyllables
'|[\\uF900-\\uFAFF]' + // IsCJKCompatibilityIdeographs
'|[\\uFE30-\\uFE4F]' + // IsCJKCompatibilityForms
'|[\\uFF01-\\uFF60]' + // Fullwidth Forms Part 1
'|[\\uFFE0-\\uFFE6]' + // Fullwidth Forms Part 2
'|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]' // Astral Planes
, 'g');
/**
 * Get string length, which counting CJK character or Emojis as 2
 * @param {string} str - string to count
 * @returns {int} - length of string
 */

function displayLength(str) {
  return _underscore.default.isString(str) ? str.replace(wideCharPattern, '12').length : 0;
}

function getLength(str, distinguishWideChar) {
  if (distinguishWideChar === void 0) {
    distinguishWideChar = false;
  }

  return distinguishWideChar ? displayLength(str) : _underscore.default.size(str);
} // eslint-disable-next-line no-control-regex


var IsControlRegex = /[\u0000-\u001F\u007F-\u009F]/;
/**
 * Validate if string contains controlled characters, http://unicode.org/glossary/#control_codes
 * @param {String} str - String to be validated
 * @returns {Boolean} - True if string contains controlled char.
 */

var isControl = function isControl(str) {
  return IsControlRegex.test(str);
};

exports.isControl = isControl;

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateGuid = generateGuid;

/*
* Create a new guid
* @returns {String} - returns a guid
*/
function generateGuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withoutTime = withoutTime;
exports.validateDateRange = validateDateRange;
exports.lastNDate = lastNDate;
exports.firstDateNMonthsAgo = firstDateNMonthsAgo;
exports.lastDateNMonthsAgo = lastDateNMonthsAgo;
exports.todayNYearsAgo = todayNYearsAgo;
exports.firstDateNYearsAgo = firstDateNYearsAgo;
exports.getUtcTime = getUtcTime;
exports.getTimestamp = getTimestamp;
exports.dateRangeEquals = dateRangeEquals;
exports.convertDateBetweenTimeZones = convertDateBetweenTimeZones;
exports.convertMachineDateToUTCDate = convertMachineDateToUTCDate;
exports.convertUTCDateToMachineDate = convertUTCDateToMachineDate;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env browser */

/*
* Returns a copy of the passed in Date with hours/minutes/seconds/milliseconds set to zero.
* @param {Date} date - Date to remove time information from
* @returns {Date} - Copy of passed in date
*/
function withoutTime(date) {
  if (!date) {
    return date;
  }

  var returnDate = new Date(date.valueOf());
  returnDate.setHours(0, 0, 0, 0);
  return returnDate;
}
/**
 * Validates if the date range passed in is incorrect. It ignores the time values.
 * @param { Date } [minDate] - The minimum date that can be selected.
 * @param { Date } [maxDate] - The maximum date that can be selected.
 * @param { Date } [selectedDate] - The date to pre-select in the datepicker.
 * @returns {String[]} - Array of error strings.
 * @throws Will throw if passed in date range is not valid.
 */


function validateDateRange(minDate, maxDate, selectedDate) {
  var selected = withoutTime(selectedDate);
  var min = withoutTime(minDate);
  var max = withoutTime(maxDate);
  var errors = [];

  if (min && max && min > max) {
    errors.push('MinDateLaterThanMaxDate');
  }

  if (selected && min && selected < min) {
    errors.push('MinDateLaterThanSelectedDate');
  }

  if (selected && max && selected > max) {
    errors.push('SelectedDateLaterThanMaxDate');
  }

  return errors;
}
/**
 * Private function to check if date is valid
 * @param {Object} date - Object to check
 * @returns {Boolean} - True if object is a valid date
 * @private
*/


function isValidDate(date) {
  return _underscore.default.isDate(date);
}
/**
 * Get the date N days ago
 * @param {Date} dateTime - The input date object
 * @param {Number} [lookBackDays=0] - Number of days to remove
 * @returns {Date} - date object with new parameters, null if date is invalid
 */


function lastNDate(dateTime, lookBackDays) {
  if (lookBackDays === void 0) {
    lookBackDays = 0;
  }

  return isValidDate(dateTime) ? new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - lookBackDays) : null;
}
/**
 * Get first date of the month N months ago
 * @param {Date} dateTime - The input date object
 * @param {Number} [lookBackMonths=0] - Number of months to remove
 * @returns {Date} - Date object with new parameters
 */


function firstDateNMonthsAgo(dateTime, lookBackMonths) {
  if (lookBackMonths === void 0) {
    lookBackMonths = 0;
  }

  return isValidDate(dateTime) ? new Date(dateTime.getFullYear(), dateTime.getMonth() - lookBackMonths, 1) : null;
}
/**
 * Get last date of the month N months ago
 * @param {Date} dateTime - The input date object
 * @param {Number} [lookBackMonths=0] - Number of months to remove
 * @returns {Date} - Date object with new parameters
 */


function lastDateNMonthsAgo(dateTime, lookBackMonths) {
  if (lookBackMonths === void 0) {
    lookBackMonths = 0;
  }

  return isValidDate(dateTime) ? lastNDate(firstDateNMonthsAgo(dateTime, lookBackMonths - 1), 1) : null;
}
/**
 * Get today for N years ago
 * @param {Date} dateTime - The input date object
 * @param {Number} [lookBackYears=0] - Number of years to remove
 * @returns {Date} - Date object with new parameters
 */


function todayNYearsAgo(dateTime, lookBackYears) {
  if (lookBackYears === void 0) {
    lookBackYears = 0;
  }

  return isValidDate(dateTime) ? new Date(dateTime.getFullYear() - lookBackYears, dateTime.getMonth(), dateTime.getDate()) : null;
}
/**
 * Get first date of the year N years ago
 * @param {Date} dateTime - The input date object
 * @param {Number} [lookBackYears=0] - Number of years to remove
 * @returns {Date} - Date object with new parameters
 */


function firstDateNYearsAgo(dateTime, lookBackYears) {
  if (lookBackYears === void 0) {
    lookBackYears = 0;
  }

  return isValidDate(dateTime) ? new Date(dateTime.getFullYear() - lookBackYears, 0, 1) : null;
}
/**
 * Get the current UTC time
 * @returns {String} - the current utc datetime
 */


function getUtcTime() {
  return new Date().toJSON();
}
/**
 * Get the current timestamp
 * @returns {number} - the timestamp since epoch in milliseconds
 */


function getTimestamp() {
  // TODO: this method should not be here, as it depends on Web API performance
  if (window.performance && window.performance.now && window.performance.timing) {
    return window.performance.timing.navigationStart + window.performance.now();
  }

  return Date.now();
}
/**
 * Check if the given two date ranges equal
 * @param {Object} firstRange - The first input range
 * @param {Object} secondRange - The second input range
 * @returns {Boolean} - Two ranges equal
 */


function dateRangeEquals(firstRange, secondRange) {
  function convertForComparison(range) {
    var dates = _underscore.default.pick(range, 'start', 'end', 'key');

    if (range.compared) {
      _underscore.default.extend(dates, {
        comparedStart: range.compared.start,
        comparedEnd: range.compared.end
      });
    }

    return dates;
  }

  if (!firstRange || !secondRange) {
    return false;
  }

  return JSON.stringify(convertForComparison(firstRange)) === JSON.stringify(convertForComparison(secondRange));
}

function convertDateBetweenTimeZones(date, i18n, _a) {
  var _b = _a === void 0 ? {} : _a,
      from = _b.from,
      to = _b.to;

  var dateString = i18n.formatDate(date, {
    timeZone: from
  });
  return i18n.parseDate(dateString, {
    timeZone: to
  });
}

function convertMachineDateToUTCDate(date, i18n) {
  return convertDateBetweenTimeZones(date, i18n, {
    from: null,
    to: 'UTC'
  });
}

function convertUTCDateToMachineDate(date, i18n) {
  return convertDateBetweenTimeZones(date, i18n, {
    from: 'UTC',
    to: null
  });
}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataURItoBlob = dataURItoBlob;
exports.convertImage2File = convertImage2File;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env browser */
// this file depends on Web API atob, Blob, File, it should not be in this project
function dataURItoBlob(dataURI) {
  var reg = /:(.+?);/;
  var arrs = dataURI.split(',');

  var header = _underscore.default.first(arrs);

  var content = _underscore.default.last(arrs);

  var type = 'image/png';
  var byteString = atob(content);
  var array = new Uint8Array(byteString.length);

  for (var i = 0; i < byteString.length; i += 1) {
    array[i] = byteString.charCodeAt(i);
  }

  if (reg.test(header)) {
    type = header.match(reg)[1];
  }

  return new Blob([array], {
    type: type
  });
}
/**
 * Convert image string to File object
 * @param {string} img image string to be convertImage2File
 * @param {string} name file name of image
 * @returns {File} File object
 */


function convertImage2File(img, name) {
  var blob = dataURItoBlob(img);

  var postfix = _underscore.default.last(blob.type.split('/'));

  return new File([blob], name + "." + postfix, {
    type: blob.type,
    lastModified: Date.now()
  });
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLastPromise = withLastPromise;
exports.createAsyncToken = createAsyncToken;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _bluebird = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function returns a new "guarded" function. The guarded function behaves like this:
 * - everytime it is called it is going to call the promiseFactory function to
 * generate a new promise and remember it as the last promise;
 * - the guarded function returns a process handle object, which has the cancel function,
 * which can be used to ignore the results of the last promise, and, instead trigger
 * the cancel() callback;
 * - when the "last promise" finishes either finish or fail callback will be triggered,
 * depending on the outcome
 * of the last promise.
 * @param {Object} options - the options object
 * @param {Function} options.promiseFactory - the function that returns a new promise.
 * The factory will be called with the arguments passed to the guarded function.
 * @param {Function} options.finish - the function that will be called when the last
 * promise is resolved. The only argument to this function is the value the value from
 * the last promise.
 * @param {Function} options.fail - a function that is called when the last promise is
 * failed. The only
 * argument to this function is the error from the last promise.
 * @param {Function} options.cancel - a function that is called when the last promise is canceled.
 * No arguments are passed in. This function will be called not early than the next
 * scheduler iteration, after a call to process handle's cancel() function.
 * @returns {Function} - the "guarded" function. See description.
 */
function withLastPromise(options) {
  var promiseFactory = options.promiseFactory,
      finish = options.finish,
      _a = options.cancel,
      cancel = _a === void 0 ? _underscore.default.noop : _a,
      _b = options.fail,
      fail = _b === void 0 ? _underscore.default.noop : _b;
  var lastPromise;
  var lastPromiseCanceled = false;

  var finishProcess = function finishProcess(error, result) {
    if (lastPromiseCanceled) {
      cancel();
    } else if (error) {
      fail(error);
    } else {
      finish(result);
    }
  };

  var guardedFunction = function guardedFunction() {
    var factoryArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      factoryArgs[_i] = arguments[_i];
    }

    lastPromise = promiseFactory.apply(void 0, factoryArgs);
    lastPromiseCanceled = false;

    var processHandle = function (promise) {
      promise.then(function (result) {
        if (promise === lastPromise) {
          finishProcess(undefined, result);
        } // skipping the results, since a new promise has started since
        // or the last one was canceled

      }, function (error) {
        if (promise === lastPromise) {
          finishProcess(error);
        } // skipping the error, since a new promise has started since
        // or the last one was canceled

      });
      return {
        cancel: function cancel() {
          lastPromiseCanceled = true;
        }
      };
    }(lastPromise);

    return processHandle;
  };

  return guardedFunction;
}

var ASYNC_STATUS;

(function (ASYNC_STATUS) {
  ASYNC_STATUS["SUCCESS"] = "SUCCESS";
  ASYNC_STATUS["ERROR"] = "ERROR";
  ASYNC_STATUS["CANCELLED"] = "CANCELLED";
})(ASYNC_STATUS || (ASYNC_STATUS = {}));

;
/**
 * This function returns an async token, which allows the caller to cancel a promise.
 * The token behaves in the following way:
 *  - The token is created using the function, however needs to be finalizes with .on().
 *  - Only one of the callbacks will ever be called (onCancel, onSuccess, onError)
 *  - If the token is cancelled, as long as the promise hasn't been resolved,
 *    onCancel will be synchronously called and all references will be released.
 * @param {Object} promise - the promise
 * @param {Object} options - the options to create async token
 * @param {Function} options.cancelCallback
 * This callback is intended to be provided by a component that returns async token
 * from one of its interface method, and helps handle cancellation specific to the component
 * @returns {Object} asyncToken - the cancelable async token
 * @returns {Function} asyncToken.chain - (resolve, reject)
 * Allows the user to chain more async tasks,
 * similar to .then(resolve, reject), however will be cancelable by the token.
 * @returns {Function} asyncToken.on - ({onCancel, onSuccess, onError})
 * finalizes the token with three callbacks.
 * Only one will ever be called. If no onError function is submitted, it will re-throw any errors.
 * the last promise.
 * @returns {Function} asyncToken.cancel - if promise has resolved, will be a noop.
 * Otherwise will stop any more tasks or callbacks from being called,
 * and will synchronously call onCancel callback.
 */

function createAsyncToken(promise, options) {
  if (!promise) {
    throw new Error('promise is a required parameter');
  } // declare scoped variables


  var currentPromise = promise;
  var promiseChain = [];
  var callbacks = null; // Implement functions

  function queueNextWork() {
    currentPromise.then(function (result) {
      finishProcess(ASYNC_STATUS.SUCCESS, result);
    }, function (error) {
      finishProcess(ASYNC_STATUS.ERROR, error);
    });
  }

  ;

  function dequeuePromise(status, result) {
    var _a = promiseChain.shift(),
        resolve = _a.resolve,
        reject = _a.reject;

    if (status === ASYNC_STATUS.ERROR) {
      if (reject) {
        currentPromise = reject(result);
      } else {
        // if no reject function was provided, rerun finishProcess, don't call queueNextWork
        finishProcess(status, result);
        return;
      }
    } else {
      currentPromise = resolve(result);
    }

    queueNextWork();
  }

  ;

  function finishProcess(status, result) {
    if (callbacks == null) {
      // Noop
      return;
    }

    var _a = callbacks.onSuccess,
        onSuccess = _a === void 0 ? _underscore.default.noop : _a,
        _b = callbacks.onError,
        onError = _b === void 0 ? function (err) {
      throw err;
    } : _b,
        _c = callbacks.onCancel,
        onCancel = _c === void 0 ? _underscore.default.noop : _c;

    if (status === ASYNC_STATUS.CANCELLED) {
      cleanup();
      onCancel();
    } else if (!_underscore.default.isEmpty(promiseChain)) {
      dequeuePromise(status, result);
    } else if (status === ASYNC_STATUS.ERROR) {
      cleanup();
      onError(result);
    } else {
      cleanup();
      onSuccess(result);
    }
  }

  function cleanup() {
    // cleanup all scoped references to unblock garbage collector
    callbacks = null;
    promiseChain = [];
    currentPromise = null;
  }

  var asyncToken = {
    chain: function chain(resolve, reject) {
      if (reject === void 0) {
        reject = null;
      }

      if (!_underscore.default.isNull(callbacks)) {
        throw new Error('Cannot call .chain after calling .on');
      } // wrap callbacks to allow async


      promiseChain.push({
        resolve: _bluebird.default.method(resolve),
        reject: reject == null ? null : _bluebird.default.method(reject)
      });
      return asyncToken;
    },
    on: function on(_a) {
      var onSuccess = _a.onSuccess,
          onError = _a.onError,
          onCancel = _a.onCancel;

      if (!_underscore.default.isNull(callbacks)) {
        throw new Error('Cannot call .on multiple times');
      }

      callbacks = {
        onSuccess: onSuccess,
        onError: onError,
        onCancel: onCancel
      }; // .on will finalize the token, begin work

      queueNextWork();
      return asyncToken;
    },
    cancel: function cancel() {
      options && options.cancelCallback && options.cancelCallback();
      finishProcess(ASYNC_STATUS.CANCELLED);
      return asyncToken;
    }
  };
  return asyncToken;
}

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorToGrayscale = colorToGrayscale;
exports.contrastColor = contrastColor;
exports.toDec = toDec;
exports.toHex = toHex;

/* eslint-disable no-bitwise */
function numberToRgb(rgbInteger) {
  return {
    red: (rgbInteger & 0xff0000) >> 16,
    green: (rgbInteger & 0x00ff00) >> 8,
    blue: rgbInteger & 0x0000ff
  };
}
/**
 * Converts an RGB color to its grayscale equivalent. Useful for determining if a color should be
 * contrasted against white or black.
 * @see {@link https://www.w3.org/TR/AERT/#color-contrast}
 * @param {Number} rgbInteger - Number that represents an RGB color, e.g. 15792383.
 * @returns {Number} Grayscale value of the number, e.g. 246.
 */


function colorToGrayscale(rgbInteger) {
  var rgb = numberToRgb(rgbInteger); // calculate grayscale value based on how humans perceive luminance in RBG

  return Math.round(0.299 * rgb.red + 0.587 * rgb.green + 0.114 * rgb.blue);
}
/**
 * Returns black if the grayscale equivalent of given color is <50% gray, otherwise returns white.
 * @param {Number} rgbInteger - Number that represents an RGB color, e.g. 15792383.
 * @returns {Number} Number that represents RGB black or RGB white.
 */


function contrastColor(rgbInteger) {
  var grayscale = colorToGrayscale(rgbInteger);
  return grayscale >= 256 / 2 ? 0 : 0xffffff;
}
/**
 * Convert a RGB hexadecimal color value into decimal.
 * @param {String} color - RGB 6-digit hexademical color, e.g. '#ff0000'
 * @returns {Number} Decimal representation, e.g. 16711680.
 */


function toDec(color) {
  return parseInt(color.substr(1), 16);
}
/**
 * Convert a decimal number into 6-digit hexademical.
 * @param {Number} color - Number value of an RGB color, e.g. 15792383
 * @returns {String} 6-digital hexademical representation, e.g. 'f0f9ff'
 */


function toHex(color) {
  return ("000000" + color.toString(16)).substr(-6);
}

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toStringBase64 = toStringBase64;
exports.parseIntBase64 = parseIntBase64;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_+';
/**
 * translate int to base-64 representation
 * @param {Number} integer None negative integer to translate
 * @returns {String} encoded base-64 string
 */

function toStringBase64(integer) {
  if (!_underscore.default.isNumber(integer) || integer % 1 !== 0 || integer < 0) {
    throw new Error('unknown data type, none negative integer only');
  }

  if (integer === 0) {
    return map[0];
  }

  var result = '';
  var dividend = integer;

  while (dividend > 0) {
    var remainder = dividend % 64;
    result = map[remainder].concat(result);
    dividend = Math.floor(dividend / 64);
  }

  return result;
}
/**
 *
 * @param {String} code, string output of toStringBase64
 * @returns {Number} the original integer number
 */


function parseIntBase64(code) {
  var result = 0;
  var remain = code.slice();

  while (remain.length > 0) {
    result = result * 64 + map.indexOf(remain[0]);
    remain = remain.slice(1);
  }

  return result;
}

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;

var Cache =
/** @class */
function () {
  function Cache(max) {
    if (max === void 0) {
      max = 200;
    }

    this.max = max;
    this.lruTrigger = max / 2;
    this.cache = new window.Map();
  }

  Cache.prototype.get = function (key) {
    var item = this.cache.get(key);

    if (this.cache.size > this.lruTrigger && item) {
      // refresh key
      this.cache.delete(key);
      this.cache.set(key, item);
    }

    return item;
  };

  Cache.prototype.set = function (key, val) {
    if (this.cache.size > this.lruTrigger) {
      // refresh key
      if (this.cache.has(key)) {
        this.cache.delete(key);
      } else if (this.cache.size == this.max) {
        this.cache.delete(this.first());
      }
    }

    this.cache.set(key, val);
  };

  Cache.prototype.first = function () {
    return this.cache.keys().next().value;
  };

  return Cache;
}();

function resolveFromCache(args, index, cache, func) {
  var key = args[index];
  var result = cache.get(key);

  if (index >= args.length - 1) {
    // reached last of arg
    if (result && !(result instanceof Cache)) {
      return result; // found actual result
    } // no result found, save the result as new entry


    var toCache = func.apply(undefined, args);
    cache.set(key, toCache);
    return toCache;
  } // not finished searching yet


  if (result instanceof Cache) {
    return resolveFromCache(args, index + 1, result, func); // found nested Map, go deeper
  } // create nested Cache with key and continue


  var nestedCache = new Cache();
  cache.set(key, nestedCache);
  return resolveFromCache(args, index + 1, nestedCache, func);
}

function memoize(func) {
  var memoized = function memoized() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return resolveFromCache(args, 0, memoized.cache, func);
  };

  memoized.cache = new Cache();
  return memoized;
}

/***/ })

/******/ });
});
